export const urls = {
  privacyPolicy:
    "https://thedatalab.com/data-readiness-assessment-privacy-notice/",
  termsAndConditions:
    "https://thedatalab.com/terms-and-conditions-of-use-data-readiness-assessment",
};
